import { usePickupTime } from '@/hooks/usePickupTime';
import { FormattedMessage } from 'react-intl';
import useToggle from '@/hooks/useToggle';
import './PickUpBanner.scss';
import { Image } from '@/components/Image';

export const PickUpBanner = () => {
  const { pickupDate, pickupTime, pickupDateTwo, pickupTimeTwo, quickPickupDate, isSamePickupTime, isBetweenTime } =
    usePickupTime();
  const pickupAvailableBadge = useToggle({ showing: false });

  return (
    <div className="w-full flex items-center gap-4">
      <div className="flex flex-col gap-[6px]">
        <div className="flex items-center gap-2">
          <span className="text-[18px] font-bold text-black">
            🔔 <FormattedMessage id="today_pick_up_schedule" defaultMessage="Today’s pick-up schedule" />
          </span>
          {quickPickupDate && (
            <>
              <div className="h-[10px] bg-[#e0e0e0]" />
              <span
                className="text-[13px] font-medium text-[#4d4d4d] flex items-center gap-1 cursor-pointer"
                onClick={pickupAvailableBadge.open}
              >
                <FormattedMessage id="express_pick_up_is_available" defaultMessage="Express Pick-up is available" />
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <Image src="/icons/support.svg" alt="support-svg" width={16} height={16} />
                  {/* {pickupAvailableBadge.isShowing && (
                    <NotificationBottomBadge
                      position={{ top: -65, left: -251 }}
                      message={
                        <div>
                          <p>{intl.formatMessage({ id: 'pick_up_badge_desc_1' })}</p>
                          <p>{intl.formatMessage({ id: 'pick_up_badge_desc_2' })}</p>
                        </div>
                      }
                      onClose={() => pickupAvailableBadge.close()}
                    />
                  )} */}
                </div>
              </span>
            </>
          )}
        </div>
        <div className="h-[30px] w-[890px] overflow-hidden flex items-center px-3 bg-[#fff2f2] rounded text-[13px] font-medium">
          {isBetweenTime && !isSamePickupTime ? (
            <div className="flex flex-col gap-2 pickup-banner-list">
              <div className="flex items-center gap-1">
                <span className="text-[#ff6060] m-0">
                  [
                  <FormattedMessage id="pick_up_notice_if_one" defaultMessage={'If the order is completed by 4:00 PM'} />]
                </span>
                <FormattedMessage
                  id="pick_up_notice_if_one_desc"
                  defaultMessage={'Pick-up available from {pickupDate} {pickupHour} PM'}
                  values={{ pickupDate, pickupHour: pickupTime }}
                />
              </div>
              <div className="flex items-center gap-1">
                <span className="text-[#ff6060] m-0">
                  [
                  <FormattedMessage id="pick_up_notice_if_two" defaultMessage={'If the order is completed after 4:00 PM'} />]
                </span>
                <FormattedMessage
                  id="pick_up_notice_if_two_desc"
                  defaultMessage={'Pick-up available from {pickupDateTwo} {pickupHour} PM'}
                  values={{ pickupDateTwo, pickupHour: pickupTimeTwo }}
                />
              </div>
              <div className="flex items-center gap-1">
                <span className="text-[#ff6060] m-0">
                  [
                  <FormattedMessage id="pick_up_notice_if_one" defaultMessage={'If the order is completed by 4:00 PM'} />]
                </span>
                <FormattedMessage
                  id="pick_up_notice_if_one_desc"
                  defaultMessage={'Pick-up available from {pickupDate} {pickupHour} PM'}
                  values={{ pickupDate, pickupHour: pickupTime }}
                />
              </div>
              <div className="flex items-center gap-1">
                <span className="text-[#ff6060] m-0">
                  [
                  <FormattedMessage id="pick_up_notice_if_two" defaultMessage={'If the order is completed after 4:00 PM'} />]
                </span>
                <FormattedMessage
                  id="pick_up_notice_if_two_desc"
                  defaultMessage={'Pick-up available from {pickupDateTwo} {pickupHour} PM'}
                  values={{ pickupDateTwo, pickupHour: pickupTimeTwo }}
                />
              </div>
            </div>
          ) : (
            <FormattedMessage
              id="pick_up_notice_one"
              defaultMessage={'Pick-up available from {pickupDate} {pickupHour} PM'}
              values={{ pickupDate, pickupHour: pickupTime }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PickUpBanner;
